module.exports = __webpack_public_path__ + "static/media/casa.9fa176e4.jpg";